/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { useAuthContext } from "../context/authContext";
import { ScreenLayout } from "./style";
function LoginLayout() {


  const { authInfo } = useAuthContext();


  const navigate=useNavigate();
  useEffect(()=>{
if(authInfo?.[0]?.first_name){
  navigate("/dashboard",{replace:true})
}
  },[authInfo?.[0]?.first_name]);

  return (
    <>
      <ScreenLayout>
        <Outlet />
      </ScreenLayout>
    </>
  );
}

export default LoginLayout;
